import classNames from "classnames";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import styles from "../style.module.scss";
import { routeConstant } from "shared/routes/routeConstant";
import { roundNum } from "shared/utils/helper";

interface navItemInterface extends SideBarItemPathType {
  setIsOpen: (val: boolean) => void;
  isBlank?: boolean;
}

const NavItem = ({
  title,
  Icon,
  path,
  subPaths,
  isBlank,
  setIsOpen,
}: navItemInterface) => {
  const {
    theme: { theme },
    count,
    breadcrumb: { prePath },
  } = useSelector((state: any) => state?.root);
  const location = useLocation();
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (
      location.pathname.includes("organization") &&
      location.pathname.includes("evaluation-record")
    ) {
      if (path === routeConstant.organizations.path) {
        setActive(true);
      }
    } else if (
      location.pathname ===
      routeConstant.continuePendingEvaluation.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else if (
      location.pathname ===
      routeConstant.evaluationRecordDetail.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else if (
      location.pathname ===
      routeConstant.organizationDetail.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else if (
      location.pathname ===
      routeConstant.editOrganization.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else if (
      location.pathname === routeConstant.addOrganization.path &&
      path === routeConstant.organizations.path
    ) {
      setActive(true);
    } else if (path === location.pathname) {
      setActive(true);
    } else {
      setActive(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <Link
        className={classNames(
          theme === "dark" ? styles.darkNavIcon : styles.lightNavIcon,
          active ? styles.activeNavItemContainer : styles.navItemContainer,
          "w-full"
        )}
        target={isBlank ? "_blank" : ""}
        to={path ? path : ""}
        onClick={() => {
          setIsOpen(false);
        }}
      >
        {Icon ? (
          <img src={Icon} alt="" className={classNames(styles.icon)} />
        ) : null}

        <label className={classNames(styles.heading)} role="button">
          {title}
        </label>
        {title === routeConstant.requestedEvaluation.title && (
          <div className={classNames(styles.badge)}>
            {roundNum(String(count?.req ?? 0), 1)}
          </div>
        )}
        {title === routeConstant.organizations.title && (
          <div className={classNames(styles.badge)}>
            {roundNum(String(count?.orgs ?? 0), 1)}
          </div>
        )}
        {title === routeConstant.contact.title && (
          <div className={classNames(styles.badge)}>
            {roundNum(String(count?.complaints ?? 0), 1)}
          </div>
        )}
      </Link>
      <div
        className={classNames(styles.subPathsList, "w-full justify-between")}
      >
        {subPaths?.map((subPath: SideBarItemPathType, index: number) => {
          return <SubPath key={index} subPath={subPath} />;
        })}
      </div>
    </>
  );
};

const SubPath = ({ subPath }: any) => {
  const location = useLocation();

  const [isActivePath, setIsActivePath] = useState<boolean>(false);

  useEffect(() => {
    if (location.pathname === subPath?.path) {
      setIsActivePath(true);
    } else {
      setIsActivePath(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  return (
    <Link
      to={subPath.path ? subPath.path : ""}
      className={classNames(
        isActivePath
          ? styles.activeSubNavItemContainer
          : styles.navItemContainer,
        "w-full pr-3 justify-between"
      )}
    >
      <div className={classNames("flex items-center")}>
        <div className={classNames(styles.icon)} />
        <label className={classNames(styles.heading)} role="button">
          {subPath.title}
        </label>
      </div>
    </Link>
  );
};

export default NavItem;
